let isDebounceAllowedToRun = true;

export function debounce(callback: () => void, delay = 300) {
  if (isDebounceAllowedToRun) {
    callback();
    isDebounceAllowedToRun = false;
    setTimeout(() => {
      isDebounceAllowedToRun = true;
    }, delay);
  }
}
